<template>
  <div class="item-box-content" style="padding-bottom:0px;">
    <el-form>
      <el-row>
        <el-col :span="16">
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label="交货设置：" label-width="95px">
                <span v-if="contractOverview.signState!==1">{{queryParams.deliverySetting===1?'现货现发,货期到货后发货':'整单到期发货'}}</span>
                <el-select v-else v-model="queryParams.deliverySetting">
                  <el-option label="现货现发,货期到货后发货" :value="1"></el-option>
                  <el-option label="整单到期发货" :value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-show="queryParams.deliverySetting===2">
              <el-form-item label="整单约定发货日期：" label-width="130px">
                <span v-if="contractOverview.signState!==1">{{queryParams.deliveryDate|dateFilterD}}</span>
                <el-date-picker v-else v-model="queryParams.deliveryDate" :picker-options="$store.state.Sell.time" type="date" placeholder="选择日期"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import { formatDate } from '@/util/tool'
export default {
  props: ['contractOverview'],
  data () {
    return {
      queryParams: {
        deliverySetting: 1,
        deliveryDate: ''
      }
    }
  },
  watch: {
    contractOverview: {
      handler (val) {
        this.queryParams.deliverySetting = (val.deliverySetting === 0 ? 1 : val.deliverySetting)
        this.queryParams.deliveryDate = val.deliveryDate
      },
      keep: true
    }
  },
  filters: {
    dateFilterD (time) { // 时间戳
      return time === null ? '' : formatDate(new Date(time), 'yyyy-MM-dd')
    }
  }
}
</script>
